import { render, staticRenderFns } from "./LIST_MATCH_TEXT_INPUT.vue?vue&type=template&id=ec1e2c74&scoped=true&"
import script from "./LIST_MATCH_TEXT_INPUT.vue?vue&type=script&lang=js&"
export * from "./LIST_MATCH_TEXT_INPUT.vue?vue&type=script&lang=js&"
import style0 from "./LIST_MATCH_TEXT_INPUT.vue?vue&type=style&index=0&id=ec1e2c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1e2c74",
  null
  
)

export default component.exports